<div class="date-filter">
  <div class="date-filter__date-wrapper">
    <div *ngIf="showMessage">
      <label class="bz-label-field" *ngIf="message">{{message}}</label>
      <label class="bz-label-field" *ngIf="!message">{{'GLOBAL.DATE_RANGE' | translate}}</label>
    </div>
    <div class="date-filter__date">
      <div class="bz-input-icon bz-space--inline-s" [ngClass]="{'disabled-input': isDisabled}">
        <input  class="bz-input bz-input-icon__input bz-space--inline-s"
                autocomplete="off"
                placeholder="{{'GLOBAL.FROM' | translate}}"
                mask="00/00/0000"
                id="date-from"
                #dpFrom="bsDatepicker"
                (focusin)="dpTo.hide()"
                [(ngModel)]="dateMin"
                (click)="setDatePickerActive('dpFrom')"
                (ngModelChange)="executeFilter()"
                [bsConfig]="{ maxDate: dateMax, showWeekNumbers: false  }"
                [disabled]="isDisabled"
                bsDatepicker>
        <svg class="bz-icn bz-space--inline-s" height="32px" width="32px" (click)="setDatePickerActive('dpFrom'); dpFrom.show()" [ngClass]="{'disabled': isDisabled}">
          <use href="#icon-calendar"></use>
        </svg>
      </div>
      <div class="bz-input-icon" [ngClass]="{'disabled-input': isDisabled}">
        <input  class="bz-input bz-input-icon__input bz-space--inline-s"
                autocomplete="off"
                placeholder="{{'GLOBAL.TO' | translate}}"
                mask="00/00/0000"
                id="date-to"
                #dpTo="bsDatepicker"
                (focusin)="dpFrom.hide()"
                [(ngModel)]="dateMax"
                (click)="setDatePickerActive('dpTo')"
                (ngModelChange)="executeFilter()"
                [bsConfig]="{ minDate: dateMin, showWeekNumbers: false, maxDate: dateMaxFuture }"
                [disabled]="isDisabled"
                bsDatepicker>
        <svg class="bz-icn bz-space--inline-s" height="32px" width="32px" (click)="setDatePickerActive('dpTo'); dpTo.show()" [ngClass]="{'disabled': isDisabled}">
          <use href="#icon-calendar"></use>
        </svg>
      </div>
    </div>
  </div>
  <div class="date-filter__selector">
    <ng-content></ng-content>
  </div>
  <div class="date-filter__button" *ngIf="!isEventChange">
    <bzg-button-primary (click)="isValidDate(dateMin) && isValidDate(dateMax) && filter()" [disabled]="!isValidDate(dateMin) || !isValidDate(dateMax)">
      {{'GLOBAL.APPLY' | translate}}
    </bzg-button-primary>
  </div>
</div>

